import styled from 'styled-components';

export const StyledDiv = styled.div`
  margin: 10px 0px 0px 0px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;

  #help-links-container {
    text-align: center;
  }

  section {
    box-shadow: none;
  }
`;
